<template>

<div class="main clients">

	<div class="list-view">

	<h1>Manage Clients</h1>

		<div v-if="!showDetail" class="sub-header">
			<div class="input-with-control">
				<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @search="getList()" v-focus>
				<div class="button action input-go" @click="getList()"><i class="fas fa-search"></i></div>
			</div>
			<div  class="controls">
				<pagination v-if="!loading" :paging="paging" @updatePage="goToPage"></pagination>
			</div>
		</div>

		<div v-else class="sub-header detail-sub-header">
			<div class="detail-title">{{ clientDetail.company_name || 'N/A' }}</div>
			<div class="previous-next">
				<template v-if="list.length > 0 && client_id != 'new'">
					<span :class="['previous', { disabled: clientDetailListIndex == 0 }]" @click="getPreviousItem()">&lang; Prev</span>
					<span :class="['next', { disabled: clientDetailListIndex == list.length - 1 }]" @click="getNextItem()">Next &rang;</span>
				</template>
			</div>
			<div class="detail-title-meta" v-if="client_id != 'new'"><label>Client ID: </label>{{ client_id }}</div>
		</div>

		<div class="filters">
			<template v-if="!showDetail">
				<div class="title">Client Type</div>
				<select v-model="filters.client_type_id" @change="getList()">
					<option value=''>Select...</option>
					<option v-for="(clientType, index) in clientTypes" :value="clientType.client_type_id">{{ clientType.description }}</option>
				</select>
				<div class="title">State</div>
				<state-select type="text" placeHolder="Select..." @updateSelected="updateSelectedState"></state-select>
				<div class="divider"></div>

				<div class="title">Status</div>
				<ul class="checkbox-group">
					<li>
						<span :class="['pointer', 'far', filters.cc_failed ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('cc_failed')"></span>
						<label>CC Failed</label>
					</li>
					<li>
						<span :class="['pointer', 'far', filters.internal_use_only ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('internal_use_only')"></span>
						<label>Demo</label>
					</li>
					<li>
						<span :class="['pointer', 'far', filters.inactive ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('inactive')"></span>
						<label>Inactive</label>
					</li>
				</ul>
				<div class="divider"></div>
				<router-link tag="div" :to="'/admin/clients/' + (client_type_id ? 'client-type/' + client_type_id + '/' : '') +  'client/new'" :class="['button', client_id == 'new' ? 'disabled' : 'action']">Create A Client</router-link>
				<div class="divider"></div>
				<div :class="['extra-menu-item', gettingExport ? 'disabled' : '']" @click="gettingExport = true">Export CSV</div>
				<div class="extra-menu-item" @click="getList()">Reload Report</div>

			</template>
			<template v-if="showDetail">
				<div :class="['filter-list-button-large', { active: showDetailTab == 'company' }]" @click="fetchDetailTab('company')">Client Info</div>
				<div :class="['filter-list-button-large', { active: showDetailTab == 'distributors' }]" @click="fetchDetailTab('distributors')">Distributors</div>
				<div :class="['filter-list-button-large', { active: showDetailTab == 'payment_processor' }]" @click="fetchDetailTab('payment_processor')">Payment Processor</div>
				<div :class="['filter-list-button-large', { active: showDetailTab == 'checkout_settings' }]" @click="fetchDetailTab('checkout_settings')">Checkout Settings</div>
				<div :class="['filter-list-button-large', { active: showDetailTab == 'social_analytics' }]" @click="fetchDetailTab('social_analytics')">Social & Analytics</div>
				<div :class="['filter-list-button-large', { active: showDetailTab == 'user' }]" @click="fetchDetailTab('user')">Primary User</div>
				<div class="divider"></div>
				<button class="button neutral" @click="logInAsDealer()">Log In As Dealer</button>
				<button class="button neutral" @click="managePaymentAccount()">Manage Subscription</button>
				<button class="button neutral" @click="cancel()">Back To List</button>
			</template>

		</div>

		<div v-if="!showDetail" class="list">
		    <table v-if="list.length > 0" class="data-list" cellpadding="0" cellspacing="0">
				<thead>
					<tr>
						<th class="list left">ID</th>
						<th class="list left">Company</th>
						<th class="list left">Start Date</th>
						<th class="list center">CC Setup</th>
						<th class="list center">CC Failed</th>
						<th class="list center">Demo</th>
						<th class="list center">Inactive</th>
					</tr>
				</thead>
				<tbody>
					<router-link tag="tr" :to="'/admin/clients/' + (client_type_id ? 'client-type/' + client_type_id + '/' : '') +  'client/' + item.client_id" v-for="item in list" class="clickable-list-item" :key="item.client_id">
						<td class="list">{{ item.client_id }}</td>
						<td class="list">{{ item.company_name }}</td>
						<td class="list">{{ item.start_date }}</td>
						<td class="list center"><i v-if="item.subscription_id" class="fas fa-check"></i></td>
						<td class="list center"><i v-if="item.client_account_update == 1" class="fas fa-check"></i></td>
						<td class="list center"><i v-if="item.internal_use_only == 1" class="fas fa-check"></i></td>
						<td class="list center"><i v-if="item.inactive == 1" class="fas fa-check"></i></td>
					</router-link>
				</tbody>
			</table>

			<div v-else class="empty-list">This list is empty</div>
		</div>

		<div v-if="showDetail" class="detail client-detail">

			<div v-if="showDetailTab == 'company'" class="three-one-columns" style="grid-column-gap: 3em;">
				<contact-detail-form :clientId="client_id" :contact="clientDetail" :addressNotRequired="true" :emailRequired="true" :hideDLInputs="true" :hideNotes="true" :hideControls="true" @cancel="cancel" @update="updateClient" :ref="'client_detail_' + client_id" />
				<div>
					<label>Client Type</label>
					<select v-model="clientDetail.client_type_id">
						<option value=''>Select...</option>
						<option v-for="(clientType, index) in clientTypes" :value="clientType.client_type_id">{{ clientType.description }}</option>
					</select>

					<label>Client Group</label>
					<select v-model="clientDetail.client_group_id">
						<option value=''>Select...</option>
						<option v-for="(clientGroup, index) in clientGroups" :value="clientGroup.client_group_id">{{ clientGroup.description }}</option>
					</select>

					<label>Time Zone</label>
					<select v-model="clientDetail.timezone_id">
						<option value=''>Select...</option>
						<option v-for="(timeZone, index) in timeZones" :value="timeZone.timezone_id">{{ timeZone.description }}</option>
					</select>

					<label>Source</label>
					<select v-model="clientDetail.source_id">
						<option value=''>Select...</option>
						<option v-for="(source, index) in sources" :value="source.source_id">{{ source.description }}</option>
					</select>

					<label>Notes</label>
					<textarea v-model="clientDetail.client_notes" />

					<div class="two-columns">
						<label class="checkbox">
							<input type="checkbox" v-model="clientDetail.internal_use_only" value="1">
							<span><i class="fas fa-check-circle"></i>Is Demo</span>
						</label>

						<label class="checkbox">
							<input type="checkbox" v-model="clientDetail.inactive" value="1">
							<span><i class="fas fa-check-circle"></i>Is Inactive</span>
						</label>
					</div>

				</div>

				<div class="detail-controls">
					<div :class="['button', saving ? 'disabled' : 'action']" @click="saveClientDetail()">Save Client Info</div>
				</div>

			</div>

			<div v-if="showDetailTab == 'distributors'" class="three-one-columns" style="grid-column-gap: 3em;">
				<div>
					<div v-for="(distributor, index) in distributors" style="border-bottom: 1px solid #ccc;">
						<h3>{{ distributor.company_name }} ({{ distributor.distributor_code }})</h3>
						<div class="two-columns">
							<div>
								<div style="margin: 0 0 0.5em 0;">
									<label>Can order from...</label>
									<div v-for="(location, index) in distributor.locations">
										<input type="checkbox" v-model="location.client_location" /> {{ location.description }}
									</div>
								</div>
								<div style="margin: 0 0 0.5em 0;">
									<label>Uses price tier...</label>
									<div v-for="(price_tier, index) in distributor.price_tiers">
										<input type="checkbox" v-model="price_tier.client_price_tier" /> {{ price_tier.description }}
									</div>
								</div>
								<div v-if="distributor.offers_firearms_dropship" style="margin: 0 0 0.5em 0;">
									<input type="checkbox" v-model="distributor.firearms_drop_ship" /> Enable Firearms Dropship
								</div>
							</div>
							<div v-if="distributor.distributor_code == 'LIP'">
								<label>Fulfillment Email Address</label>
								<input type="text" v-model="distributor.client_distributor.fulfillment_username" />
								<label>Fulfillment Password</label>
								<input type="text" v-model="distributor.client_distributor.fulfillment_password" />
								<label>Dropship Email Address</label>
								<input type="text" v-model="distributor.client_distributor.dropship_username" />
								<label>Dropship Password</label>
								<input type="text" v-model="distributor.client_distributor.dropship_password" />
							</div>
							<div v-if="distributor.distributor_code == 'RSR'">
								<label>Account Number</label>
								<input type="text" v-model="distributor.client_distributor.account_number" />
								<label>Dropship Account</label>
								<input type="text" v-model="distributor.client_distributor.fulfillment_username" />
								<label>FTP Password</label>
								<input type="text" v-model="distributor.client_distributor.fulfillment_password" />
							</div>
							<div v-if="distributor.distributor_code == 'SS'">
								<label>Account Number</label>
								<input type="text" v-model="distributor.client_distributor.account_number" />
								<label>Password</label>
								<input type="text" v-model="distributor.client_distributor.fulfillment_password" />
							</div>
							<div v-if="distributor.distributor_code == 'ZAN'">
								<label>Main Account Username</label>
								<input type="text" v-model="distributor.client_distributor.account_number" />
								<label>Main Account Passcode</label>
								<input type="text" v-model="distributor.client_distributor.api_key" />
								<label>Firearms Dropship Account Username</label>
								<input type="text" v-model="distributor.client_distributor.fulfillment_username" />
								<label>Firearms Dropship Account Passcode</label>
								<input type="text" v-model="distributor.client_distributor.fulfillment_password" />
								<label>Accessories Dropship Account Username</label>
								<input type="text" v-model="distributor.client_distributor.dropship_username" />
								<label>Accessories Dropship Account Passcode</label>
								<input type="text" v-model="distributor.client_distributor.dropship_password" />
							</div>
						</div>
					</div>
				</div>
				<div>
					<h2>Preference Order</h2>
					<draggable handle=".drag" :sort="true" v-model="clientDistributors" @end="endDrag" tag="div">
						<div v-for="(distributor, index) in clientDistributors" class="four-one-columns" style="padding: 0.5em 0; border-bottom: 1px solid #ccc;">
							<div>{{ distributor.company_name }}</div>
							<div class="drag right"><i class="fas fa-grip-vertical"></i></div>
						</div>
					</draggable>
				</div>
			</div>

		</div>

	</div>

    <message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

</div>

</template>

<script>
import StateSelect from '@/components/StateSelect.vue'
import ContactDetailForm from '@/components/ContactDetailForm'
import LabelRequired from '@/components/LabelRequired.vue'
export default {
	name: 'clients',
	props: ['client_type_id','client_id'],
    components: {
        'state-select': StateSelect,
        'contact-detail-form': ContactDetailForm,
        'label-required': LabelRequired
    },
	data() {
		return {
			loading: false,
			showFilters: true,
			clientTypes: [],
			filters: {
				page: 1,
				search_term: '',
				client_type_id: '',
				state: '',
				cc_failed: '',
				internal_use_only: '',
				inactive: ''
			},
			paging: {},
			list: [],
			clientDetail: {},
			clientDetailListIndex: 0,
			clientGroups: [],
			sources: [],
			timeZones: [],
			distributors: [],
			clientDistributors: [],
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			showDetail: false,
			showDetailTab: '',
			showToolTip: false,
			toolTipMessage: '',
			saving: false,
			gettingExport: false
		}
	},
	created() {
		this.getClientTypes()
		if (this.client_id) {
			this.getDetail(this.client_id)
		}
	},
	computed: {
		hasFilters() {
			for (const [key, value] of Object.entries(this.filters)) {
				if (['search_term', 'client_type_id'].includes(key) && value) {
					return true
				}
			}
			return false
		},
	},
	watch: {
		'$route': function(newRoute) {
			if (this.client_id) {
				if (this.client_id == 'new') {
					this.newClient()
				} else {
					this.getDetail(this.client_id)
				}
			} else {
				this.getList()
			}
		}
	},
	methods: {
        getClientTypes() {
            this.apiCall({ destination: 'get_list_client_types' }).then(obj => {
                this.clientTypes = obj.client_types
				if (!this.client_id) {
					this.getList()
				}
            }).catch(err => {
                console.log(err);
            })
        },
		getList() {
			if (this.loading) { return }
			this.loading = true
			this.showDetail = false
			if (this.client_type_id) {
				this.filters.client_type_id = this.client_type_id
			}
			this.apiCall({ destination: 'get_list_clients', data: this.filters }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.list = obj.clients
					this.paging = obj.paging
				}
			}).catch(err => {
				console.log(err)
			})
		},
		clientTypeCode(clientTypeId) {
			for (let i = 0; i < this.clientTypes.length; i++) {
				if (this.clientTypes[i].client_type_id == clientTypeId) {
					return this.clientTypes[i].client_type_code
				}
			}
		},
		updateSelectedState(state) {
			this.filters.state = state
			this.getList()
		},
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			this.getList()
		},
		clearFilters() {
			this.filters = {
				page: 1,
				search_term: '',
				user_type_id: '',
			}
			if (this.user_type_id) {
				this.$router.push('/admin/clients')
			} else {
				this.getList()
			}
		},
		doSearch() {
			if (this.filters.search_term) {
				this.getList()
			}
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		fetchDetailTab(detailTab, forceReload = false) {
			if (this.client_id == 'new') { return }
			this.showDetailTab = detailTab
			this.loading = true
			this.apiCall({ destination: 'get_item_client_' + detailTab, data: { client_id: this.client_id } }).then(obj => {
				if (obj.status == 'success') {
					switch(detailTab) {
						case 'company':
							this.clientDetail = obj.detail
							this.clientGroups = obj.client_groups
							this.sources = obj.sources
							this.timeZones = obj.timezones
							break
						case 'distributors':
							this.distributors = obj.distributors
							this.clientDistributors = obj.client_distributors
							break
						case 'payment_processor':
							break
						case 'checkout_settings':
							break
						case 'social_analytics':
							break
						case 'user':
							break
					}
				}
				this.showDetail = true
				this.loading = false
			}).catch(err => {
				console.log(err)
			})
		},
		getPreviousItem() {
			if (this.clientDetailListIndex == 0) { return }
			this.getDetail(this.list[this.clientDetailListIndex - 1])
		},
		getNextItem() {
			if (this.clientDetailListIndex == this.list.length - 1) { return }
			this.getDetail(this.list[this.clientDetailListIndex + 1])

		},
		getDetail(item) {
			for (let i = this.list.length - 1; i >= 0; i--) {
				if (this.list[i].client_id == this.client_id) {
					this.clientDetailListIndex = i
					break;
				}
			}
			this.fetchDetailTab('company', true)
		},
		newClient() {
			this.clientDetail = {
				client_id: 'new',
				source_id: '',
				client_type_id: '',
				timezone_id: '',
				client_group_id: ''
			}
			this.showDetail = true
		},
		updateClient(editedClientContact) {
			this.clientDetail = editedClientContact
		},
		saveClientDetail() {
			this.message = ''
			this.messageStatus = ''
			if (!this.clientDetail.company_name) {
				this.message = "Company name is required"
				this.messageStatus = 'invalid'
				return false
			}
			if (!this.clientDetail.client_type_id) {
				this.message = "Client type is required"
				this.messageStatus = 'invalid'
				return false
			}
			this.saving = true
			this.message = "Saving client info..."
			this.apiCall({ destination: 'save_item_client_company', data: this.clientDetail }).then(obj => {
				this.saving = false
				this.messageTimeout = 2000
				if (obj.status == 'success') {
					this.message = "Client info saved!"
					if (this.client_id = 'new') {
						this.$router.push('/admin/clients/client/' + obj.client_id)
					}
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		endDrag(event) {
			// just drag-sorted distributors, so set priority to new index order
			this.clientDistributors.forEach(function (item, index) {
				item.priority = index
			})
		},
		cancel() {
			this.userDetail = {}
			this.showDetail = false
			let backRoute = '/admin/clients' + (this.client_type_id ? '/client-type/' + this.client_type_id : '')
			this.$router.push(backRoute)
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
